<div [ngClass]="cssService.cardClass" style="overflow: hidden" fxFlex>

  <div class="px-4 py-2 bg-orange-300 text-white text-center">
    <span class="">{{'Information'|translate}} </span>
  </div>

  <div fxLayout="column" style="padding: 10px" fxLayoutGap="10px">

    <div style="
            max-height: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
            overflow-wrap: break-word;
          " [ngStyle.xs]="{ 'max-height.px': 70 }">
      <div [innerHTML]="saleMethod.description_order" style="overflow: hidden" class="text-sm text-center"></div>
    </div>

    <div class="flex flex-col">
      <button [ngClass]="cssService.defaultNegativeDialogButton" class="w-full"
        (click)="dialogService.openDescriptionOrderDial()"
          angulartics2On="click" angularticsAction="openOrderInfoDial" angularticsCategory="pointsOfSale">
        <span>{{ "other.seemore" | translate | capitalize }}</span>
      </button>
    </div>
  </div>

</div>
